var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalysis(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.665 1.666H1.332v4h13.333v-4z",
    stroke: "#19233C",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.332 13.677l4.059-4.1 2.193 2.1L10.264 9l1.494 1.456",
    stroke: "#19233C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.668 5.39v8.667M1.332 5.39v4.667M4.34 14.334h10.328M5.668 3.666h7M3.332 3.666h.333",
    stroke: "#19233C",
    strokeLinecap: "round"
  })));
}
export default SvgAnalysis;